import { z } from 'zod';

// schema for the form values used in TaskModal
export const taskFormSchema = z.object({
    title: z.string().min(1, "Title is required"),
    description: z.string().optional().nullable(),
    status: z.enum(["todo", "inprogress", "done"]),
    assignedToId: z.string().optional().nullable(),
    isPublic: z.boolean(),
});

export type TaskForm = z.infer<typeof taskFormSchema>;
